/*
Utility mixins:
utils.translate: adds a translate() method.
utils.apartmentUrl: adds a apartmentUrl() method.
*/

import globals from "../../lib/globals";
import translate from "../../lib/translate";

const utils = {
  translate: {
    methods: {
      translate,
    },
  },
  hasApartmentUrl: {
    methods: {
      hasApartmentUrl(apartment) {
        return (
          globals.language &&
          apartment.city &&
          apartment.township &&
          apartment.housing_locality &&
          apartment.slug
        );
      },
    },
  },
  apartmentUrl: {
    methods: {
      apartmentUrl(apartment) {
        const language = globals.language;
        const slugCity = apartment.city.slug;
        const slugTownship = apartment.township.slug;
        const slugHousinglocality = apartment.housing_locality.slug;
        const slugApartment = apartment.slug;

        const path = {
          fi: `asuntohaku/${slugCity}/${slugTownship}/${slugHousinglocality}/${slugApartment}`,
          en: `en/apartment-search/${slugCity}/${slugTownship}/${slugHousinglocality}/${slugApartment}`,
          sv: `sv/sok-bostad/${slugCity}/${slugTownship}/${slugHousinglocality}/${slugApartment}`,
        }[language];
        return `${globals.urlBase}/${path}`;
      },
    },
  },
  housingLocalityUrl: {
    methods: {
      housingLocalityUrl(housingLocality) {
        const language = globals.language;
        const slug = housingLocality.slug;

        const slugParent = {
          fi: "kohteet",
          en: "locations",
          sv: "bostad",
        }[language];

        const path = {
          fi: `${slugParent}/${slug}`,
          en: `en/${slugParent}/${slug}`,
          sv: `sv/${slugParent}/${slug}`,
        }[language];

        return `${globals.urlBase}/${path}`;
      },
    },
  },
  generalHelpers: {
    methods: {
      /**
       * Returns the GET parameters present in the current URL as strings
       * e.g. avainasunnot.fi/?asd=1&dsa=2
       * => { asd: "1", dsa: "2" }
       */
      getJSONFromURL() {
        const q = window.location.search.slice(1);
        const result = {};

        q.split("&").forEach((part) => {
          const item = part.split("=");
          result[item[0]] = decodeURIComponent(item[1]);
        });

        return result;
      },
    },
  },
};

export default utils;
